<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="490px">    
           <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item prop="status" label="状态">
                    <el-radio-group v-model="form.status">
                        <el-radio :label="1">启动</el-radio>
                        <el-radio :label="2">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item   prop="cycleType" label="任务周期">
                    <el-select v-model="form.cycleType" clearable @change="cycleTypeChange" placeholder="请选择" style="width:325px;">
                        <el-option
                            v-for="item in cycleTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item   prop="remindDays" label="任务提醒" v-if="form.cycleType != ''">
                    <div style="width:328px;">
                        <!-- 每月：1~31 -->
                        <el-checkbox-group v-model="form.remindDays" v-if="form.cycleType == 1" @change="changeTaskTitle">
                            <el-checkbox v-for="d in 31" :key="d" :label="d" border size="mini" style="margin:2px;">{{d < 10 ? '0' + d : d}}</el-checkbox>
                        </el-checkbox-group>
                        <!-- 每周：星期一~星期日 -->
                        <el-checkbox-group v-model="form.remindDays" v-if="form.cycleType == 2" @change="changeTaskTitle">
                            <el-checkbox v-for="w in weekDays" :key="w.value" :label="w.value" border size="mini" style="margin:2px;">{{w.label}}</el-checkbox>
                        </el-checkbox-group>
                        <div style="margin-top:8px;">
                            提醒时间：
                            <el-time-picker v-model="form.remindTime" placeholder="选择时间" format="HH:mm" value-format="HH:mm" style="width:150px;"></el-time-picker>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item   prop="" label="任务关联模块">
                    <div border style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width:325px;">
                        <el-checkbox v-for="module in moduleArr" :key="module.id"  v-model="form.taskModule" :label="module.id" border size="medium" style="margin:5px;">
                            {{module.moduleTitle}}
                        </el-checkbox>
                    </div>
                </el-form-item>
           
                <el-form-item  prop="" label="任务接收者">
                    <el-button @click="getMoreUser()">{{form.receiveTaskUsersLabel}}</el-button>
                </el-form-item>

                <el-form-item  prop="executeCount" label="评价次数">
                    <el-input v-model="form.executeCount" @input="changeTaskTitle" maxlength="5" style="width:65px;" type="number"></el-input>
                </el-form-item>

                <el-form-item  prop="" label="任务生成标题">
                    <div v-if="form.taskTitle != null && form.taskTitle!=''" style="color:red">
                        {{form.taskTitle}}
                    </div>
                    <div v-else style="color:red">
                        无
                    </div>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框多人 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import { MessageBox } from 'element-ui';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        name:"TaskConfig",
        data(){
            return{
                visible:false,
                transferVisible:false,
                form:{
                    deptId:"",
                    status:"",
                    cycleType:"",
                    taskModule:[],
                    receiveTaskUsers:[],
                    receiveTaskUsersLabel:"",
                    executeCount:3,
                    taskTitle:"",
                    remindDays:[],
                    remindTime:""
                },
                depts:[],
                cycleTypes:[{
                    value: 1,
                    label: '每月'
                }, {
                    value: 2,
                    label: '每周'
                }],
                statusOptions:[
                    { value: 1, label: '启动' },
                    { value: 2, label: '停用' }
                ],
                moduleArr:[],
                weekDays:[
                    {value:1,label:'星期一'},{value:2,label:'星期二'},{value:3,label:'星期三'},
                    {value:4,label:'星期四'},{value:5,label:'星期五'},{value:6,label:'星期六'},{value:7,label:'星期日'}
                ],
                rules: {
                    status: [
                        { required: true, message: '请选择状态', trigger: 'change' }
                    ],
                    cycleType: [
                        { required: true, message: '请选择任务周期', trigger: 'blur' }
                    ],
                    executeCount: [
                        { required: true, message: '请选择评价次数', trigger: 'blur' }
                    ],
                    remindDays: [
                        { required: true, message: '请选择任务提醒日期', trigger: 'change', type: 'array', min: 1 }
                    ],
                    remindTime: [
                        { required: true, message: '请选择提醒时间', trigger: 'change' }
                    ]
                }
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=deptId;
                this.form.receiveTaskUsers=[];
                this.form.receiveTaskUsersLabel="请选择";
                this.form.taskTitle="";
                this.form.remindDays=[];
                this.form.remindTime="";
                this.form.status=1;
                // 初始数据
                this.getTaskModule();
            },
            // 获取任务关联模块
            getTaskModule(){
                let url  = this.moduleConfigList2Url;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.moduleArr=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.$commonFn.showTip(err,3);
                });
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            cycleTypeChange(){
                this.form.remindDays = [];
                this.changeTaskTitle();
            },
            // 生成任务标题
            changeTaskTitle(){
                 if(this.form.cycleType == 1){ // 每月
                    this.form.taskTitle="当月完成"+this.form.executeCount+"次#模块名称#任务";
                 }else if(this.form.cycleType == 2){ // 每周
                    this.form.taskTitle="本周完成"+this.form.executeCount+"次#模块名称#任务";
                 }
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        // 验证任务关联模块不能为空
                        if(this.form.taskModule.length == 0){
                            this.$commonFn.showTip("请选择任务关联模块",3);
                            return;
                        }
                        // 验证任务接收者不能为空
                        if(this.form.receiveTaskUsers.length == 0){
                            this.$commonFn.showTip("任务接收者不能为空",3);
                            return;
                        }
                        
                        let url= this.myTaskConfigSavetUrl;
                        let data = {
                            deptId:this.form.deptId,
                            status:this.form.status,
                            cycleType:this.form.cycleType,
                            taskModule:this.form.taskModule.join(','),
                            receiveTaskUsers:this.form.receiveTaskUsers.join(','),
                            executeCount:this.form.executeCount,
                            taskTitle:this.form.taskTitle,
                            remindDays:this.form.remindDays.join(','),
                            remindTime:this.form.remindTime
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });

                    }
                });
            },
            getMoreUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    console.log("部门ID："+this.form.deptId);
                    this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                })
            },
            setUser(key,label){
                this.form.receiveTaskUsers = key;
                this.form.receiveTaskUsersLabel = key.length+"人";
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/task/Add.vue